import Col from './col'

Col.install = vue => {
  vue.component(Col.name, Col)
}

export default Col
